import Vue from 'vue'
import index from './index.vue'
import '../base/common'

new Vue({
  data() {
    return {
      state: {
        configInfo:{
          step1:require('../img/step1.jpg'),
          step2:require('../img/step2.jpg'),
          step3:require('../img/step3.jpg'),
          step4:require('../img/step4.jpg')
        }
      }
    }
  },
  created() {
    Vue.prototype.$state = this.state
  },
  render: h => h(index)
}).$mount('#app')
